export function isEmpty<T>(value: T[]): boolean {
  const isEmpty = value.length === 0 ? true : false;
  return isEmpty;
}
